import Action from '.';

export function changeLang(data) {
    return {
        type: Action.CHANGE_LANG,
        locale: data==='en' ? 'th' : 'en'
    }
}

